import { useEffect } from 'react';

/* useScript allows you to add external js for a single component
 * @param {string} url Url for the external javascript
 * @param {boolean=false} skip Optional dependency to skip loading of script
 * @param {boolean=true} async
 * @param {boolean=true} defer
 */
export default function useScript(
  url,
  skip = false,
  async = true,
  defer = true
) {
  useEffect(() => {
    if (skip) return;

    const script = document.createElement('script');

    script.src = url;
    script.async = async;
    script.defer = defer;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [skip]);
}
